<mat-expansion-panel
  class="info-panel remove-mat-expansion-panel-padding header-actions-panel"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  [expanded]="panelOpenState">

  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="section-header-container">
        <div class="d-flex">
          <p class="overline grey1 semibold section-title">{{sysText.emailContent | uppercase}}</p>
          @if (templateDetails?.missingDetails?.hasOwnProperty('subjectHtml')
            || templateDetails?.missingDetails?.hasOwnProperty('bodyHtml')) {
            <app-status-chip
              class="status-chip"
              [icon]="'error_outline'"
              [ngStyle]="chipStyles.warnBg"
              [removeMargin]="true"
                        [tooltip]="(
                            (templateDetails?.missingDetails?.hasOwnProperty('subjectHtml') 
                                && !templateDetails?.missingDetails?.hasOwnProperty('bodyHtml')) ? sysText.emailContent_subjectRequired :
                            (!templateDetails?.missingDetails?.hasOwnProperty('subjectHtml') 
                                && templateDetails?.missingDetails?.hasOwnProperty('bodyHtml')) ? sysText.emailContent_bodyRequired : 
                            sysText.emailContent_required)">
            </app-status-chip>
          }
        </div>
        <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- beside the header, not inside it (the header is a button, so controls in it can't be used from the keyboard) -->
  <div ngProjectAs="mat-expansion-panel-header" class="header-actions">
    @if (templateDetails.canEditEmail) {
      <button
        mat-icon-button
        color="accent"
        [attr.aria-label]="sysText.edit_ariaLabel"
        (click)="editEmailContent()">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>

  <div class="main-content flex">
    <p class="body2 grey2">{{sysText.emailSubjectLine}}</p>
    <div class="editor-container">
      <editor
        #subEditor
        [(ngModel)]="templateDetails.subjectHtml"
                [init]="{ 
                width: '100%',
                min_height: 53,
                max_height: 75,
                iframe_aria_text: sysText.emailSubjectLine,
                menubar: false,
                statusbar: false,
                toolbar: false,
                setup: tinySetup,
                paste_block_drop: true,
                paste_as_text: true,
                promotion: false,
                license_key: tinyMceKey,
                plugins: ['autoresize'],
                autoresize_bottom_margin: 5,
                content_style: editorStyle}">
      </editor>
    </div>
    <p class="body2 grey2">{{sysText.emailBody}}</p>
    <div class="editor-container">
      <editor
        #bodyEditor
        [(ngModel)]="templateDetails.bodyHtml"
                [init]="{ 
                width: '100%',
                min_height: 53,
                max_height: 500,
                iframe_aria_text: sysText.emailBody,
                menubar: false,
                statusbar: false,
                toolbar: false,
                setup: tinySetup,
                paste_block_drop: true,
                paste_as_text: true,
                promotion: false,
                license_key: tinyMceKey,
                plugins: ['autoresize'],
                autoresize_bottom_margin: 5,
                content_style: editorStyle}">
      </editor>
    </div>
  </div>
</mat-expansion-panel>